import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { grey } from "@mui/material/colors";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { drawerOpen } = useSelector((state) => state.menu);
    const { t } = useTranslation()
    return (
        <Box
            sx={{
                width: "auto",
                background: grey[300],
                height: 35,
                minHeight: 35,
                zIndex: 999,
                bottom: 0,
                right: 0,
                left: 0,
                paddingLeft: drawerOpen ? "10%" : 0,
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box >
                <Typography variant="subtitle2" color="secondary" align="center" sx={{ fontWeight: 500 }}>
                    Powered by WiData - {t('Version')} {process.env.REACT_APP_ENVIRONMENT}
                </Typography>
            </Box>
        </Box>
    );
};

export default Footer;
